import React from 'react';
import Card from '../../ui/Card';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Cell, ReferenceLine } from 'recharts';
const ChannelWiseROIChart: React.FC = () => {
  const data = [{
    channel: 'Digital',
    roi: 342,
    spend: 133.7,
    revenue: 457.2,
    color: '#10b981'
  }, {
    channel: 'BTL',
    roi: 287,
    spend: 113.8,
    revenue: 326.8,
    color: '#3b82f6'
  }, {
    channel: 'TV',
    roi: 245,
    spend: 82.5,
    revenue: 202.1,
    color: '#8b5cf6'
  }, {
    channel: 'Print',
    roi: 198,
    spend: 45.8,
    revenue: 90.7,
    color: '#f59e0b'
  }, {
    channel: 'Outdoor',
    roi: 128,
    spend: 38.2,
    revenue: 48.9,
    color: '#ef4444'
  }];
  const avgROI = data.reduce((sum, item) => sum + item.roi, 0) / data.length;
  return <Card className="p-6 mb-8" data-id="element-6908">
      <h3 className="text-lg font-semibold text-gray-800 mb-2" data-id="element-6909">
        Channel-wise ROI Performance
      </h3>
      <p className="text-sm text-gray-600 mb-4" data-id="element-6910">
        Return on Investment by marketing channel (%)
      </p>
      <ResponsiveContainer width="100%" height={350} data-id="element-6911">
        <BarChart data={data} data-id="element-6912">
          <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" data-id="element-6913" />
          <XAxis dataKey="channel" tick={{
          fontSize: 12
        }} data-id="element-6914" />
          <YAxis tick={{
          fontSize: 12
        }} label={{
          value: 'ROI %',
          angle: -90,
          position: 'insideLeft',
          fontSize: 12
        }} data-id="element-6915" />
          <Tooltip contentStyle={{
          backgroundColor: 'white',
          border: '1px solid #e5e7eb',
          borderRadius: '8px'
        }} formatter={(value: number, name: string) => {
          if (name === 'ROI') return `${value}%`;
          return value;
        }} data-id="element-6916" />
          <Legend data-id="element-6917" />
          <ReferenceLine y={avgROI} stroke="#9ca3af" strokeDasharray="3 3" label={{
          value: `Avg: ${avgROI.toFixed(0)}%`,
          position: 'right',
          fontSize: 11
        }} data-id="element-6918" />
          <Bar dataKey="roi" name="ROI %" data-id="element-6919">
            {data.map((entry, index) => <Cell key={`cell-${index}`} fill={entry.color} data-id="element-6920" />)}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
      <div className="mt-6 pt-6 border-t border-gray-200" data-id="element-6921">
        <div className="grid grid-cols-5 gap-4" data-id="element-6922">
          {data.map((channel, index) => <div key={index} className="text-center" data-id="element-6923">
              <div className="text-xs text-gray-600 mb-1" data-id="element-6924">
                {channel.channel}
              </div>
              <div className="text-2xl font-bold mb-1" style={{
            color: channel.color
          }} data-id="element-6925">
                {channel.roi}%
              </div>
              <div className="text-xs text-gray-500" data-id="element-6926">
                Spend: ₹{channel.spend}L
              </div>
              <div className="text-xs text-gray-500" data-id="element-6927">
                Revenue: ₹{channel.revenue}L
              </div>
            </div>)}
        </div>
      </div>
      <div className="mt-4 p-4 bg-green-50 rounded-lg border border-green-200" data-id="element-6928">
        <div className="flex items-start" data-id="element-6929">
          <div className="flex-shrink-0 w-2 h-2 rounded-full bg-green-600 mt-1.5 mr-2" data-id="element-6930" />
          <div className="text-sm text-green-800" data-id="element-6931">
            <span className="font-semibold" data-id="element-6932">Top Performer:</span> Digital
            channels delivering 342% ROI with ₹133.7L spend generating ₹457.2L
            in attributed revenue. Consider reallocating budget from
            underperforming Outdoor channel.
          </div>
        </div>
      </div>
    </Card>;
};
export default ChannelWiseROIChart;